/**
 * Hook: DELETE /api/t/{slug}/jds/{id}.
 *
 * Cascade: rankings, ranking_runs, interview_prep, interview_analyses,
 * ai_evaluations are scoped to the JD and removed. Candidates remain.
 *
 * On success: invalidates `['jds', tenantSlug]`. Caller routes back to
 * the list page after the mutation resolves.
 */
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { ApiError } from "@/lib/apiError";
import { apiClient } from "@/lib/apiClient";

export function useDeleteJd(): UseMutationResult<void, ApiError, string> {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const qc = useQueryClient();

  return useMutation<void, ApiError, string>({
    mutationFn: async (id) => {
      await apiClient.delete(`/api/t/${tenantSlug}/jds/${id}`);
    },
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: ["jds", tenantSlug] });
      void qc.removeQueries({ queryKey: ["jd", tenantSlug, id] });
    },
  });
}
